import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Contact, ContactPhoneNumber } from '../contracts/contact.interface';
import { TableFilter } from '../../shared/contracts/table-column.interface';

export interface ContactSearchItem {
  id: number;
  firstName?: string;
  lastName?: string;
  phoneNumbers: ContactPhoneNumber[];
}

@Injectable({ providedIn: 'root' })
export class ContactService {
  private readonly base = 'contacts';

  constructor(private http: HttpClient) {}

  getAll(page = 1, size = 20, filters: TableFilter[] = []): Observable<{ data: Contact[]; total: number }> {
    let params = new HttpParams().set('page', page).set('size', size);
    for (const f of filters) {
      params = params.append('filter_field', f.field);
      params = params.append('filter_value', f.value);
      params = params.append('filter_match', f.matchMode);
    }
    return this.http.get<{ data: Contact[]; total: number }>(`${this.base}`, { params });
  }

  getById(id: number): Observable<Contact> {
    return this.http.get<Contact>(`${this.base}/${id}`);
  }

  create(contact: any): Observable<Contact> {
    return this.http.post<Contact>(`${this.base}`, contact);
  }

  update(id: number, contact: any): Observable<Contact> {
    return this.http.put<Contact>(`${this.base}/${id}`, contact);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.base}/${id}`);
  }

  search(q: string, limit = 10): Observable<{ data: ContactSearchItem[] }> {
    const params = new HttpParams().set('q', q).set('limit', limit);
    return this.http.get<{ data: ContactSearchItem[] }>(`${this.base}/search`, { params });
  }
}
